import * as React from 'react';
import { useNavigate } from 'react-router-dom';


type Props = {
    buttonText: string,

    // onClick:(event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const HasWalletutton: React.FC<Props> = (props) => {
  const hasWalletButtonStyle: React.CSSProperties = {
      boxSizing: 'border-box',
      width: '314px',
      height: '60px',
      background: 'linear-gradient(95.13deg, #D5B6ED -0.93%, #D5E0F7 41.61%, #D4AFEB 112.51%)',
      border: '0.5px solid rgba(239, 239, 239, 0.2)',
      boxShadow: 'inset 0px 1px 0px rgba(255, 255, 255, 0.6)',
      borderRadius: '80px',
      marginBottom: '10px',
      transition: 'all 0.5s',
      backgroundImage: `url('https://nfttopshot-template.onrender.com/template-images/btn-violet-bg.png')`,
      color: 'rgba(213, 182, 237, 1)',
      fontWeight: 500,
  };
  const nav = useNavigate();
  return (
      <>
        <button 
          className='btn' 
          style={hasWalletButtonStyle} 
          id="btn-default-getnft-haswallet" 
          type="button" 
          onClick={()=>nav('/1')}
        >
          <img className="navbar-toggler-icon"  src='https://nfttopshot-template.onrender.com/template-images/wallet.png' />&nbsp;{props.buttonText}
        </button>
      </>
  );
};